import { ProfileLookupBehaviorEnum } from '../enum/profile-lookup-behavior.enum';
import { FormV2TemplateDto } from './form-v2-template.dto';

export const DonationDefaultTemplate = {
  FormElements: [
    {
      ElementType: 1,
      MetaData: {},
      DisplayValue: '<p>Donate to our organization using the form below.&nbsp;</p>\n',
      Id: 'yp1q1746l1krcmjd',
    },
    {
      ElementType: 2,
      MetaData: {
        ProfileData: { DisplayFirstName: true, DisplayLastName: true, DisplayEmail: true, DisplayWorkPhone: true, RequireFirstName: false },
      },
      Id: '5ias64nkr5ye2rze',
    },
    { ElementType: 3, MetaData: { ProfileData: { DisplayOrgName: true } }, Id: '2pm12uhn2312ge90' },
  ],
  FormSettings: {
    LoginRequired: false,
    FormPaymentOptions: { AllowCreditCard: true, CreateInvoiceChargeOnSubmit: true },
    CreateNewProfile: true,
    ProfileLookupBehavior: 1,
  },
  Title: 'Donation Form',
} as FormV2TemplateDto;

export const RenewalDefaultTemplate = {
  FormElements: [
    {
      ElementType: 3,
      MetaData: {
        ProfileData: {
          DisplayOrgName: true,
          DisplayAddress1: true,
          DisplayAddress2: true,
          DisplayCity: true,
          DisplayState: true,
          DisplayZip: true,
          DisplayWorkPhone: true,
          DisplayEmail: true,
        },
      },
      Id: 'd811lleqmjcb5giy',
    },
    {
      ElementType: 2,
      MetaData: { ProfileData: { DisplayFirstName: true, DisplayLastName: true, DisplayTitle: true, DisplayEmail: true } },
      Id: 'ellfg5my2a91eusf',
    },
  ],
  FormSettings: {
    LoginRequired: true,
    FormPaymentOptions: { AllowCreditCard: true, AllowBillMe: true, CreateInvoiceChargeOnSubmit: true },
    ProfileLookupBehavior: ProfileLookupBehaviorEnum.RelatedOrgMember,
  },
  Title: 'Renewal Form',
} as FormV2TemplateDto;

export const ProspectDefaultTemplate = {
  FormElements: [
    { ElementType: 0, DisplayValue: 'Organization/Company Information', Id: 'y2a666ox51ujvvod' },
    {
      ElementType: 3,
      MetaData: {
        ProfileData: {
          DisplayOrgName: true,
          DisplayAddress1: true,
          DisplayAddress2: true,
          DisplayCity: true,
          DisplayState: true,
          DisplayZip: true,
          DisplayWorkPhone: true,
          DisplayEmail: true,
          EmailLabel: 'Organization Email',
          DisplayWebsite: true,
          RequireOrgName: true,
          RequireEmail: true,
        },
      },
      Id: 'kp10b84ko12kw4ii',
    },
    { ElementType: 0, DisplayValue: 'Main Contact', Id: '8k13wj1631ahhcnn' },
    {
      ElementType: 2,
      MetaData: {
        ProfileData: {
          DisplayFirstName: true,
          DisplayLastName: true,
          RequireFirstName: true,
          RequireLastName: true,
          DisplayTitle: true,
          DisplayWorkPhone: true,
          DisplayEmail: true,
          RequireEmail: true,
        },
      },
      Id: 'ykazqyeq51ttyyln',
    },
  ],
  FormSettings: { LoginRequired: false, CreateNewProfile: true, AffCodes: [], NotificationToEmail: [], ProfileLookupBehavior: 0 },
  Title: 'Prospect Form',
} as FormV2TemplateDto;

export const GeneralDefaultTemplate = {
  FormElements: [
    {
      ElementType: 2,
      MetaData: { ProfileData: { DisplayFirstName: true, DisplayLastName: true, DisplayEmail: true, RequireEmail: true } },
      Id: 'zo1chgtmn1rj0z9p',
    },
    { ElementType: 3, MetaData: { ProfileData: { DisplayOrgName: true } }, Id: 'z1xvlfns81c2b65r' },
  ],
  FormSettings: {
    LoginRequired: false,
    FormPaymentOptions: { AllowCreditCard: true, CreateInvoiceChargeOnSubmit: true },
    CreateNewProfile: true,
    ProfileLookupBehavior: 1,
  },
  Title: 'General Form',
} as FormV2TemplateDto;
